import ENDPOINTS, { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'
import { QuickFilter } from '@zet/utils/Constants'

import { ILeadsFilterDto } from '../types'

const getLeadsFilterDto = (filterDto: ILeadsFilterDto) => {
  return JSON.stringify(filterDto)
}

export async function fetchLeads(
  offset = 0,
  searchText?: string | undefined,
  leadsType?: string | undefined,
  limit?: number
) {
  const response = await zetApi.request({
    url: ENDPOINTS[APP_NAME].fetchLeads.endpoint,
    method: ENDPOINTS[APP_NAME].fetchLeads.method,
    params: {
      filters: getLeadsFilterDto({
        pagination: {
          offset: offset,
          limit: limit ?? 10,
        },
        searchText: searchText as string,
        filters: Object.keys(QuickFilter).map((item) => ({
          name: QuickFilter[item].name,
          value: QuickFilter[item].value,
        })),
      }),
      ...(leadsType ? { type: leadsType } : {}),
    },
  })
  return { nextOffset: offset + 10, ...response.data?.data }
}
